import {
  Search,
  SiteNavigation,
  type SiteNavigationVariant,
} from "@replicate/ui";
import type { AccountWithAvatar } from "../types";
import AccountPicker from "./account-picker";
import type { Theme } from "./dark-mode-toggle";

export default function Navigation({
  activePath,
  isAuthenticated,
  variant = "floating",
  user,
  account,
  organizations,
  hasSuperpowers,
  theme,
}: {
  activePath: string;
  isAuthenticated: boolean;
  variant?: SiteNavigationVariant;
  user?: AccountWithAvatar;
  account?: AccountWithAvatar;
  organizations?: AccountWithAvatar[];
  hasSuperpowers: boolean;
  theme: Theme;
}) {
  const kind =
    account?.kind !== "anonymous"
      ? (account?.kind as "user" | "organization")
      : undefined;
  const username =
    account?.kind !== "anonymous" ? account?.username : undefined;

  return (
    <SiteNavigation
      variant={variant}
      avatar={
        isAuthenticated && user && account ? (
          <AccountPicker
            account={account}
            organizations={organizations || []}
            user={user}
            hasSuperpowers={hasSuperpowers}
            theme={theme}
          />
        ) : null
      }
      authState={isAuthenticated ? "authenticated" : "anonymous"}
      currentPath={activePath}
      meta={null}
      search={
        <div className="w-full max-w-lg">
          <Search
            params={{ limit: 50 }}
            authState={isAuthenticated ? "authenticated" : "anonymous"}
          />
        </div>
      }
      logo={"glyph"}
      kind={kind}
      username={username}
    />
  );
}
